import { render, staticRenderFns } from "./campaigns-page.vue?vue&type=template&id=be75184a&scoped=true&"
import script from "./campaigns-page.vue?vue&type=script&lang=js&"
export * from "./campaigns-page.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-page.vue?vue&type=style&index=0&id=be75184a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be75184a",
  null
  
)

export default component.exports